// This is just an example,
// so you can safely delete all default props below

export default {
  attendance: 'Présence',
  basic: 'De base',
  catalog: 'Catalogue',
  Center: 'Centre',
  centers: 'Centres',
  color: 'Couleur',
  communicate: 'Communication',
  discounts: 'Remises',
  displayOptions: "Options d'affichage",
  desc: 'Description',
  families: 'Familles',
  finances: 'Finance',
  groups: 'Groupe',
  locations: 'Emplacements',
  locationMessagesGroup: {
    inUseError:
      "Impossible de supprimer les emplacements en cours d'utilisation",
  },
  main: 'Principal',
  messages: {
    errors: {},
    success: 'Success',
  },
  name: 'Nom',
  organization: 'Organisation',
  programs: 'Programme',
  pods: 'Pods',
  pod: 'Pod',
  podMessagesGroup: {
    inUseError:
      "Impossible de supprimer les groupes de transport en cours d'utilisation",
  },
  rates: 'Taux',
  schedules: 'Calendrier',
  schoolMessagesGroup: {
    inUseError: "Impossible de supprimer les écoles en cours d'utilisation",
  },
  setup: 'Configurer',
  spaces: 'Espace',
  sponsors: 'Sponsors',
  sponsorSelection: 'Sélection de sponsor',
  Staff: 'Personnel',
  tasks: 'Tâches',
  theme: 'Thème',
  type: 'Taper',
  transport: 'Transport',
  schools: 'écoles',
}
